// src/utils/paymentMethods.js
export const PaymentMethodsConfig = {
    MPESA: {
      name: 'M-Pesa Vodacom MZ',
      logo: '/logos/mpesa.png',
      buttonLogo: '/logos/mpesa-button.png',
      buttonColor: '#e31837',
      buttonText: 'Pagar com M-Pesa'
    },
    EMOLA: {
      name: 'E-Mola',
      logo: '/logos/emola.png',
      buttonLogo: '/logos/emola-button.png',
      buttonColor: '#f47920',
      buttonText: 'Pagar com E-Mola'
    },
    CARTAO: {
      name: 'Debit/Credit Card',
      logo: '/logos/card-brands.png',
      buttonLogo: '/logos/card-button.png',
      buttonColor: '#1a1f71',
      buttonText: 'Pagar com Cartão'
    },
    STANDARDBANK: {
      name: 'Standard Bank',
      logo: '/logos/standardbank.png',
      buttonLogo: '/logos/standardbank-button.png',
      buttonColor: '#0033a1',
      buttonText: 'Pagar com Standard Bank'
    }
  };